<div class="component-container">
  <mat-card class="err-img-card-container">
    <mat-card-header>
      <mat-card-title class="title"
        >Looks like you might have lost your way there...</mat-card-title
      >
    </mat-card-header>
    <mat-card-content>
      <img class="err-img" src="/assets/price_checker_no_back_ground.png" alt="something" />
    </mat-card-content>
  </mat-card>
</div>
